import React from "react"
import { getMediaUrl } from "../../utils/media"

const focusFrame = (
  <svg
    className="hero-enhanced__focus"
    width="380"
    height="380"
    viewBox="0 0 380 380"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    xmlnsSerif="http://www.serif.com/"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
  >
    <path
      d="M377.54,105.049L358.669,105.049L358.669,35.757C358.669,28.479 348.061,18.87 341.782,18.87L272.491,18.87L272.491,0L340.782,0C361.044,0 377.54,16.482 377.54,36.757L377.54,105.049Z"
      style={{ fill: "white", fillRule: "nonzero" }}
    />
    <g transform="matrix(-0,1,-1,-0,378.77,1.46)">
      <path
        d="M377.54,105.049L358.669,105.049L358.669,35.757C358.669,28.479 348.061,18.87 341.782,18.87L272.491,18.87L272.491,0L340.782,0C361.044,0 377.54,16.482 377.54,36.757L377.54,105.049Z"
        style={{ fill: "white", fillRule: "nonzero" }}
      />
    </g>
    <g transform="matrix(-1,-0,0,-1,378.77,379)">
      <path
        d="M377.54,105.049L358.669,105.049L358.669,35.757C358.669,28.479 348.061,18.87 341.782,18.87L272.491,18.87L272.491,0L340.782,0C361.044,0 377.54,16.482 377.54,36.757L377.54,105.049Z"
        style={{ fill: "white", fillRule: "nonzero" }}
      />
    </g>
    <g transform="matrix(0,-1,1,0,1.23,378.54)">
      <path
        d="M377.54,105.049L358.669,105.049L358.669,35.757C358.669,28.479 348.061,18.87 341.782,18.87L272.491,18.87L272.491,0L340.782,0C361.044,0 377.54,16.482 377.54,36.757L377.54,105.049Z"
        style={{ fill: "white", fillRule: "nonzero" }}
      />
    </g>
  </svg>
)

const arrowIcon = (
  <svg
    className="hero-enhanced__cta-title-arrow"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    xmlnsSerif="http://www.serif.com/"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
    }}
  >
    <path
      d="M3,12.5L22,12.5L12.543,3.043M22,12.5L12.363,22.137"
      style={{ fill: "none", stroke: "currentColor", strokeWidth: "3px" }}
    />
  </svg>
)

const getLinkRel = target =>
  target === "_blank" ? "noopener noreferrer" : undefined

const getTitleSizeClass = titleSize => {
  const typography = titleSize || "default"
  const allowed = [
    "default",
    "header-xxl",
    "header-xl",
    "header-l",
    "header-m",
    "header-s",
    "header-xs",
    "text-m",
    "text-l",
  ]

  return allowed.includes(typography) && typography !== "default"
    ? typography
    : "header-xs"
}

const HeroEnhanced = ({
  heroEnhLabel,
  heroEnhTitle,
  heroEnhDescription,
  heroEnhButtons,
  heroEnhEmbedOrImage,
  heroEnhHeroImage,
  heroEnhHeroCtas,
}) => {
  const heroImageUrl = getMediaUrl(heroEnhHeroImage)

  return (
    <section className="hero-enhanced content">
      <div className="hero-enhanced__inner">
        <div className="content-block">
          <div className="hero-enhanced__copy centered-intro-title-holder">
            {heroEnhLabel ? (
              <div
                className="hero-enhanced__eyebrow"
                dangerouslySetInnerHTML={{ __html: heroEnhLabel }}
              />
            ) : null}

            {heroEnhTitle ? (
              <div
                className="hero-enhanced__title header-xl"
                dangerouslySetInnerHTML={{ __html: heroEnhTitle }}
              />
            ) : null}

            {heroEnhDescription ? (
              <div
                className="hero-enhanced__description text-m"
                dangerouslySetInnerHTML={{ __html: heroEnhDescription }}
              />
            ) : null}

            {heroEnhButtons?.length ? (
              <div className="hero-enhanced__buttons">
                {heroEnhButtons.map((buttonGroup, index) => {
                  const button = buttonGroup?.heroEnhButton

                  if (!button?.url || !button?.title) {
                    return null
                  }

                  return (
                    <a
                      className="button"
                      href={button.url}
                      target={button.target || "_self"}
                      rel={getLinkRel(button.target)}
                      key={index}
                    >
                      {button.title}
                    </a>
                  )
                })}
              </div>
            ) : null}

            <div className="hero-enhanced__footer">
              {heroEnhEmbedOrImage?.map((item, index) => {
                const accreditationUrl = getMediaUrl(item?.heroEnhAccLogo)

                if (item?.type === "embed" && item.heroEnhReviewEmbed) {
                  return (
                    <div
                      className="hero-enhanced__review"
                      key={index}
                      dangerouslySetInnerHTML={{
                        __html: item.heroEnhReviewEmbed,
                      }}
                    />
                  )
                }

                if (item?.type === "image" && accreditationUrl) {
                  const isSvg =
                    item.heroEnhAccLogo?.mimeType === "image/svg+xml"
                  const content = (
                    <img
                      src={accreditationUrl}
                      alt={
                        item.heroEnhAccLogo?.altText ||
                        item.heroEnhAccLogo?.title ||
                        ""
                      }
                      title={item.heroEnhAccLogo?.title || undefined}
                      width={isSvg ? 75 : undefined}
                      height={isSvg ? 75 : undefined}
                      loading="lazy"
                    />
                  )

                  return (
                    <div className="hero-enhanced__accreditation" key={index}>
                      {item.heroEnhAccLogoLink?.url ? (
                        <a
                          href={item.heroEnhAccLogoLink.url}
                          target={item.heroEnhAccLogoLink.target || "_self"}
                          rel={getLinkRel(item.heroEnhAccLogoLink.target)}
                        >
                          {content}
                        </a>
                      ) : (
                        content
                      )}
                    </div>
                  )
                }

                return null
              })}
            </div>
          </div>

          {heroImageUrl ? (
            <div className="hero-enhanced__media">
              {focusFrame}
              <img
                src={heroImageUrl}
                alt={heroEnhHeroImage?.altText || heroEnhHeroImage?.title || ""}
                title={heroEnhHeroImage?.title || undefined}
                loading="lazy"
              />
            </div>
          ) : null}
        </div>
      </div>

      {heroEnhHeroCtas?.length ? (
        <div className="hero-enhanced__ctas">
          {heroEnhHeroCtas.map((cta, index) => {
            const link = cta?.button
            const hasLink = link?.url && link?.title
            const iconUrl = getMediaUrl(cta?.icon)
            const accentStyle = cta?.accentColour
              ? { "--accent": cta.accentColour }
              : undefined

            const article = (
              <article className="hero-enhanced__cta">
                {cta?.title ? (
                  <h3
                    className={`${getTitleSizeClass(
                      cta.typography
                    )} hero-enhanced__cta-title`}
                  >
                    {iconUrl ? (
                      <div className="hero-enhanced__icon">
                        {cta.icon?.mimeType === "image/svg+xml" ? (
                          <span
                            className="hero-enhanced__icon-image hero-enhanced__icon-image--mask"
                            style={{ "--icon-src": `url('${iconUrl}')` }}
                            aria-hidden="true"
                          />
                        ) : (
                          <img
                            src={iconUrl}
                            alt={cta.icon?.altText || cta.icon?.title || ""}
                            loading="lazy"
                          />
                        )}
                      </div>
                    ) : null}
                    {cta.title}
                    {!cta?.showButton ? arrowIcon : null}
                  </h3>
                ) : null}

                <div className="hero-enhanced__cta-wrapper">
                  {cta?.subtitle || cta?.description ? (
                    <div className="hero-enhanced__cta-text">
                      {cta.subtitle ? (
                        <p className="hero-enhanced__cta-subtitle">
                          <strong>{cta.subtitle}</strong>
                        </p>
                      ) : null}
                      {cta.description ? (
                        <p className="hero-enhanced__cta-description">
                          {cta.description}
                        </p>
                      ) : null}
                    </div>
                  ) : null}

                  {hasLink && cta?.showButton ? (
                    <div className="hero-enhanced__cta-buttonwrapper">
                      <span className="button hero-enhanced__cta-button">
                        {link.title}
                      </span>
                    </div>
                  ) : null}
                </div>
              </article>
            )

            if (!hasLink) {
              return <React.Fragment key={index}>{article}</React.Fragment>
            }

            return (
              <a
                className="hero-enhanced__cta-link"
                href={link.url}
                target={link.target || "_self"}
                rel={getLinkRel(link.target)}
                style={accentStyle}
                key={index}
              >
                {article}
              </a>
            )
          })}
        </div>
      ) : null}
    </section>
  )
}

export default HeroEnhanced
